<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 교육정보 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교육정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>공장명</div>
          <p v-if="isPrint" class="print-input">{{ form.공장 }}</p>
          <ml-input v-else v-model="form.공장" readonly />
        </div>
        <div>
          <div class="flex gap-4" style="width: 500px">
            <div v-for="(item, index) in form.공장형태" :key="index">
              <PrintCheckbox v-if="isPrint" :label="item.label" :value="item.check" style="width: fit-content" class="mx-auto" />
              <vs-checkbox v-else color="secondary" v-model="item.check">{{ item.label }}</vs-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="writeGridContainer">
        <div class="writeGridLineItem" v-for="(team, teamIndex) in form.팀업체" :key="teamIndex">
          <div>{{ teamIndex === 0 ? "팀(업체)명" : "" }}</div>
          <div class="grid gap-2" :style="{ gridTemplateColumns: isPrint ? '1fr 1fr 1fr' : '38px 1fr 1fr 1fr 60px' }">
            <button v-if="!isPrint && teamIndex === 0" @click="addTeam" style="width: 37.78px; height: 37.78px; border-radius: 4px; border: 1px solid #cdcdcd">
              <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />
            </button>
            <button v-else-if="!isPrint && teamIndex !== 0" @click="removeTeam(teamIndex)" style="width: 37.78px; height: 37.78px; border-radius: 4px; border: 1px solid #cdcdcd">
              <feather-icon icon="MinusIcon" svgClasses="h-5 w-5" />
            </button>
            <div class="flex">
              <p v-if="isPrint" class="print-input w-full">{{ team.공장 ? team.공장.value : "" }}</p>
              <custom-option-selector v-else class="w-full" :readonly="board.readonly" @change="(teamData) => changeTarget1(teamIndex, teamData)" v-model="team.공장" :options="공장리스트" />
            </div>
            <div>
              <p v-if="isPrint" class="print-input w-full">{{ team.팀1차 ? team.팀1차.value : "" }}</p>
              <div v-else>
                <custom-option-selector
                  class="w-full"
                  v-show="form.팀리스트1차[teamIndex] && form.팀리스트1차[teamIndex].length > 0"
                  :readonly="board.readonly"
                  @change="(teamData) => changeTarget2(teamIndex, teamData)"
                  v-model="team.팀1차"
                  :options="teamList1(teamIndex)"
                />
                <ml-input v-show="isCustomTeam(teamIndex)" v-model="team.팀커스텀" class="mt-2 w-full" placeholder="직접입력" />
              </div>
            </div>
            <div>
              <p v-if="isPrint && team.팀2차" class="print-input w-full">{{ team.팀2차 ? team.팀2차.value : "" }}</p>
              <custom-option-selector
                v-else
                class="w-full"
                v-show="form.팀리스트1차[teamIndex] && form.팀리스트1차[teamIndex].length > 0 && form.팀리스트2차[teamIndex] && form.팀리스트2차[teamIndex].length > 0"
                :readonly="board.readonly"
                v-model="team.팀2차"
                :options="teamList2(teamIndex)"
              />
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="writeGridContainer">-->
      <!--        <div class="writeGridLineItem">-->
      <!--          <div>팀(업체)명</div>-->
      <!--          <div class="grid gap-2" :style="{ gridTemplateColumns: isPrint ? '1fr 1fr 1fr' : '40px 1fr 1fr 1fr 60px' }">-->
      <!--            <button v-if="!isPrint" @click="addTeam" style="width: 37.78px; height: 37.78px; border-radius: 8px; border: 1px solid #cdcdcd;">-->
      <!--              <feather-icon icon="PlusIcon" svgClasses="h-5 w-5" />-->
      <!--            </button>-->
      <!--            <div class="flex">-->
      <!--              <p v-if="isPrint" class="print-input w-full">{{ form.팀업체.공장? form.팀업체.공장.value : '' }}</p>-->
      <!--              <custom-option-selector-->
      <!--                v-else-->
      <!--                class="w-full"-->
      <!--                :readonly="board.readonly"-->
      <!--                @input="changeTarget1"-->
      <!--                v-model="form.팀업체.공장"-->
      <!--                :options="공장리스트"-->
      <!--              />-->
      <!--            </div>-->
      <!--            <div>-->
      <!--              <p v-if="isPrint" class="print-input w-full">{{ form.팀업체.팀1차? form.팀업체.팀1차.value : '' }}</p>-->
      <!--              <div v-else>-->
      <!--                <custom-option-selector-->
      <!--                  class="w-full"-->
      <!--                  v-show="팀리스트1차.length > 0"-->
      <!--                  :readonly="board.readonly"-->
      <!--                  @input="changeTarget2"-->
      <!--                  v-model="form.팀업체.팀1차"-->
      <!--                  :options="팀리스트1차"-->
      <!--                />-->
      <!--                <ml-input v-show="isCustomTeam" v-model="form.팀업체.팀커스텀" class="mt-2 w-full" placeholder="직접입력" />-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div>-->
      <!--              <p v-if="isPrint" v-show="form.팀업체.팀2차" class="print-input w-full">{{ form.팀업체.팀2차? form.팀업체.팀2차.value : '' }}</p>-->
      <!--              <custom-option-selector-->
      <!--                v-else-->
      <!--                class="w-full"-->
      <!--                v-show="팀리스트1차.length > 0 && 팀리스트2차.length > 0"-->
      <!--                :readonly="board.readonly"-->
      <!--                v-model="form.팀업체.팀2차"-->
      <!--                :options="팀리스트2차"-->
      <!--              />-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="writeGridContainer">
        <div>
          <div>교육인원</div>
          <div class="flex gap-2" style="align-items: center">
            <span class="whitespace-no-wrap">대상</span>
            <p v-if="isPrint" class="print-input">{{ form.교육인원대상자수 }}</p>
            <comma-input v-else v-model="form.교육인원대상자수" type="number" :readonly="board.readonly" />
            <span class="whitespace-no-wrap">명 / 참석</span>
            <p v-if="isPrint" class="print-input">{{ form.교육인원참석자수 }}</p>
            <comma-input v-else v-model="form.교육인원참석자수" type="number" readonly />
            명
          </div>
        </div>

        <div class="writeGridLineItem">
          <div>교육구분</div>
          <div class="grid" style="grid-template-columns: 300px 300px">
            <div v-for="item in 교육구분리스트" class="flex gap-2 mr-2" style="align-items: center; min-height: 40px" :key="item.text">
              <PrintRadio v-if="isPrint" :value="form.교육구분 === item.value" :label="item.text" :white-space-nowrap="true" />
              <vs-radio v-else v-model="form.교육구분" :vs-value="item.value" vs-name="교육구분" @input="selectEducationType(item)">
                <span class="whitespace-no-wrap">{{ item.text }}</span>
              </vs-radio>

              <p v-if="isPrint" v-show="form.교육구분 === item.value" class="print-input">{{ form.교육구분내용 }}</p>
              <vs-input v-else v-show="form.교육구분 === item.value" v-model="form.교육구분내용" placeholder="입력" style="width: 150px" />
            </div>
          </div>
        </div>

        <div class="writeGridLineItem" v-if="form.교육구분 === '특별안전보건'">
          <div>대상(작업명)</div>
          <custom-option-selector
            class="w-full"
            :readonly="board.readonly"
            v-model="form.특별안전보건"
            :options="getDiff"
            placeholder="1. 고압실 내 작업(잠함공법이나 그 밖의 압기공법으로 대기압을 넘는 기압인 작업실 또는 수갱 내부에서 하는 작업만 해당한다)"
            @input="changeDiff"
          />
        </div>
      </div>
    </div>

    <!-- 교육진행 -->
    <table-custom
      class="mt-6 mb-4"
      :board="board"
      :is-print="isPrint"
      :default-size="1"
      :controls="false"
      :border-x="false"
      title="교육진행"
      :tableData="[
        { id: '교육명', title: '교육(과목)명', type: 'text' },
        { id: '강사', title: '강사', type: 'text' },
        { id: '교육일자', title: '교육일자', type: 'date' },
        { id: '교육시간', title: '교육시간', type: 'period', width: '300px' },
        { id: '교육장소', title: '교육장소', type: 'text' },
        { id: '학습방법', title: '학습방법', type: 'select', selectData: 학습방법리스트 },
        { id: '평가방법', title: '평가방법', type: 'select', selectData: 평가방법리스트 },
      ]"
      v-model="form.교육진행"
    />

    <!-- 참석자 명단 -->
    <table-custom
      class="mt-6 mb-5"
      :board="board"
      :is-print="isPrint"
      :default-size="0"
      :min-size="0"
      :border-x="false"
      title="참석자 현황"
      :tableData="[
        { id: 'no', title: 'No.', type: 'no' },
        { id: '업체명', title: '부서(업체)명', type: 'text' },
        { id: '소속', title: '소속', type: 'text' },
        { id: '직책', title: '직책', type: 'text' },
        { id: '이름', title: '이름', type: 'text' },
        { id: '휴대폰번호', title: '휴대폰번호', type: 'text' },
        { id: '서명', title: '서명', type: 'sign' },
        { id: '교육평가', title: '교육평가', type: 'radio', radioItems: [{ value: '생략' }, { value: '합격' }, { value: '불합격' }], width: '236px' },
      ]"
      custom-thead
      draggable
      v-model="sortedParticipants"
    >
      <template #customHead="{allCheckValue, onClickAllCheck, mobile, readonly}">
        <fragment>
          <tr style="border-bottom: 1px solid #cdcdcd">
            <th v-if="!readonly" style="padding: 6px;">
              <div class="p-1 flex justify-center items-center">
                <vs-checkbox class="custom-checkbox justify-center mx-0" :checked="allCheckValue" @input="onClickAllCheck"></vs-checkbox>
              </div>
            </th>
            <th class="table-header">No.</th>
            <th>
              <div class="table-header" @click="onClickOrders('업체명')">
                업체명
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.업체명 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.업체명 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
            <th>
              <div class="table-header" @click="onClickOrders('소속')">
                소속
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.소속 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.소속 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
            <th>
              <div class="table-header" @click="onClickOrders('직종')">
                직종
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.직종 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.직종 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
            <th>
              <div class="table-header" @click="onClickOrders('이름')">
                이름
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.이름 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.이름 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
            <th>
              <div class="table-header" @click="onClickOrders('휴대폰번호')">
                휴대폰번호
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.휴대폰번호 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.휴대폰번호 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
            <th><div class="table-header">서명</div></th>
            <th>
              <div class="table-header" @click="onClickOrders('교육평가')">
                교육평가
                <span class="ml-1">
                <feather-icon
                  v-if="orderByParticipant.교육평가 === 'asc'"
                  icon="ChevronUpIcon"
                  svgClasses="h-4 w-4"
                />
                <feather-icon
                  v-else-if="orderByParticipant.교육평가 === 'desc'"
                  icon="ChevronDownIcon"
                  svgClasses="h-4 w-4"
                />
                </span>
              </div>
            </th>
          </tr>
        </fragment>
      </template>
      <template #buttons="{ handleAddButton, handleRemoveButton, checkData }">
        <vs-button v-if="form.참석자명단.length > 0" color="secondary" type="border" class="xl:flex-none" @click="showExcelDownload = true">엑셀 다운로드</vs-button>
        <vs-button color="secondary" class="ml-4" @click="showQRHistory = true"> QR 참석자 명단 가져오기 </vs-button>
        <vs-button color="secondary" type="border" :disabled="form.참석자명단.length < 1 || checkData.length === 0" class="ml-4" @click="handleCustomRemoveButton(checkData)"> 선택삭제 </vs-button>
      </template>
    </table-custom>

    <!-- 교재명 or 강의주제 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 교재명 or 강의주제</h5>
        </vs-col>
      </vs-row>
      <span v-if="isPrint" class="print-textarea"> {{ form.교재명 }} </span>
      <ml-textarea v-else v-model="form.교재명" :readonly="board.readonly" />
    </div>

    <!-- 참고사항 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 참고사항</h5>
        </vs-col>
      </vs-row>
      <span v-if="isPrint" class="print-textarea"> {{ form.참고사항 }} </span>
      <ml-textarea v-else v-model="form.참고사항" :readonly="board.readonly" />
    </div>

    <!-- 첨부물 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 첨부물</h5>
        </vs-col>
      </vs-row>
      <div class="flex gap-6">
        <div v-if="isPrint" class="flex gap-x-2">
          <PrintCheckbox v-for="item in form.첨부물" :key="item.label" :label="item.label" :value="item.value" style="width: fit-content" class="mx-auto" />
        </div>
        <vs-checkbox v-else class="gap-x-2" v-for="item in form.첨부물" :key="item.label" v-model="item.value" :readonly="board.readonly">
          <span class="whitespace-no-wrap">{{ item.label }}</span>
        </vs-checkbox>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="교육장면사진" placeholder="신축현장 점검" />

    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-q-r-history v-model="showQRHistory" :selected-user-ids="selectedUserIds" @select="onSelectHistory" />

    <popup-excel-download
      v-model="showExcelDownload"
      :list="getExcelList"
      title="참석자 명단"/>
  </div>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector";
import TimeSelector from "@/components/selector/TimeSelector";
import CustomOptionSelector from "@/components/selector/CustomOptionSelectorObject";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

import KPagination from "@/components/kPagination/kPagination";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { valueDisasters } from "@/util/DisasterDataUtil";
import TableCustom from "@/components/TableCustom.vue";
import SignField from "@/components/SignField.vue";
import PopupSearchEmployeeCheckbox from "@/popup/PopupSearchEmployeeCheckbox.vue";
import CustomLabel from "@/components/CustomLabel.vue";
import PopupQRHistory from "@/popup/PopupQRHistory.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import { CompanyData } from "@/data/DksteeTeamlData";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import PrintRadio from "@/components/print/PrintRadio.vue";
import educationContent from "@/views/boards/single-page/987/educationContent";
import diffData from "@/views/boards/single-page/987/DiffData";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";

export default {
  components: {
    PopupExcelDownload,
    PrintRadio,
    RadioGroup,
    PrintCheckbox,
    PopupQRHistory,
    CustomLabel,
    PopupSearchEmployeeCheckbox,
    PhotoUploadGridModule,
    FieldSelectModule,
    CustomOptionSelector,
    FileUploadModule,
    DateSelector,
    DisasterClassSelector,
    TimeSelector,
    KPagination,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
    TableCustom,
    SignField,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      // =============== 이전 문서 불러오기 ===============
      isMounted: false,
      customButton: null,
      disasterTypes: [{ text: "전체선택", value: "" }, ...valueDisasters()],
      searchTypes: [
        { value: "stdInfo.field_name", text: "현장명" },
        { value: "inputD_1", text: "재해일시" },
        { value: "inputD_3", text: "발생형태" },
        { value: "stdInfo.section", text: "소속1" },
        { value: "stdInfo.department", text: "소속2" },
        { value: "stdInfo.writer_name", text: "작성자" },
      ],
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        date: "", // 작성일
        disasterType: "", // 발생형태
        searchType: "", // 검색조건
        searchKeyword: "", // 키워드
      },

      // 종사자 정보
      showQRHistory: false,

      // 참석자현황 정렬
      orderByParticipant: {
        no: "asc",
        업체명: "asc",
        소속: "asc",
        직종: "asc",
        이름: "asc",
        휴대폰번호: "asc",
        교육평가: "asc",
      },
      lastSortedField: 'no', // 마지막 정렬된 필드 추적
      sortedParticipants: [], // 정렬된 참석자 명단

      // =============== FORM ===============
      공장리스트: CompanyData,
      교육구분리스트: [
        { value: "관리감독자교육", text: "관리감독자교육" },
        { value: "환경교육직무보수교육", text: "환경교육직무보수교육" },
        { value: "TQM교육", text: "TQM교육" },
        { value: "외부업체교육", text: "외부업체교육" },
        { value: "소방교육", text: "소방교육" },
        { value: "특별안전보건", text: "특별안전보건교육" },
        { value: "정기안전보건", text: "정기안전보건교육" },
        { value: "신입사원교육", text: "신입사원교육" },
        { value: "직무전환교육", text: "직무전환교육" },
        { value: "기타교육", text: "기타교육" },
      ],
      학습방법리스트: ["강의식", "토의식", "실기", "자율학습", "기타"],
      평가방법리스트: ["평가생략", "필기시험", "구술시험", "실기시험", "자율학습", "수료증", "학습태도"],
      form: {
        stdInfo: {},

        공장: "",
        공장형태: [
          { check: false, label: "직영" },
          { check: false, label: "수급업체" },
        ],
        팀업체: [
          {
            공장: {},
            팀1차: {},
            팀2차: {},
            팀커스텀: "",
          },
        ],
        팀리스트1차: [[]],
        팀리스트2차: [[]],
        교육인원대상자수: 0,
        교육인원참석자수: 0,
        교육구분: "",
        교육구분내용: "",
        특별안전보건: "",
        교육진행: [],
        참석자명단: [],
        교재명: "",
        참고사항: `ㅇ 참고사항

본 문서는 사내교육 시 적용되는 문서입니다.(보관기한 : 5년)
교육결과 의견란에는 각 해당자의 적정 의견을 기재하시기 바랍니다.
[교육담당자] 직영 : 안전환경담당자, 안전장 사내수급업체 : 대표, 수급업체 관리감독자
(* 안전환경담당자 or 안전장이 없는 경우: 관리감독자)
[교육책임자] 직영: 팀장, 사내수급업체:대표
교육참석자 현황을 허위로 등록하였을 경우 관련 법령에 의거 처벌을 받을수 있습니다.`,
        첨부물: [
          { label: "교육참석자현황", value: false },
          { label: "교육교재", value: false },
          { label: "교육장면사진", value: false },
          { label: "기타자료", value: false },
        ],

        photoList: [],
        fileList: [],
      },

      showExcelDownload: false,
    };
  },
  computed: {
    // computed
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    getDiff() {
      const found = diffData.find((item) => item.value === "특별안전보건");
      return found && found.child ? found.child : [];
    },
    selectedUserIds() {
      return this.form.참석자명단.filter((item) => item.user_id).map((item) => item.user_id);
    },
    // 참석자 명단
    getExcelList() {
      return this.form.참석자명단 ? this.form.참석자명단.map((data) => {
        return {
          'No.': this.form.참석자명단.indexOf(data) + 1,
          '부서(업체)명': data.업체명 ? data.업체명 : '',
          '소속': data.소속 ? data.소속 : '',
          '직종': data.직종 ? data.직종 : '',
          '이름': data.이름 ? data.이름 : '',
          '휴대폰번호': data.휴대폰번호 ? data.휴대폰번호 : '',
          '교육평가': data.교육평가 ? data.교육평가 : '',
          '직책' : data.직책 ? data.직책 : '',
        }
      }) : []
    },
  },
  watch: {
    "value": {
      important: true,
      deep: true,
      handler(value) {
        if (value) {
          const keys = Object.keys(value);
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key];
            }
          }

          // form.팀업체는 Array 타입인데, 과거에 저장된 데이터의 경우 오브젝트로 저장되어 있다.
          // 이런 경우, 오브젝트를 첫번째 요소로 하는 배열로 변환한다.
          if (value.팀업체 && !Array.isArray(value.팀업체)) {
            this.form.팀업체 = [value.팀업체];
            this.form.팀리스트1차 = [[]];
            this.form.팀리스트2차 = [[]];
          }
        }
      },
    },
    "form": {
      immediate: true,
      deep: true,
      handler(value) {
        // value.summary = {
        //   안전보건교육_현장명: [],
        //   안전보건교육_교육구분: [],
        //   안전보건교육_현장별교육구분: [],
        // };
        //
        // value.summary["안전보건교육_현장명"].push({
        //   [this.form.stdInfo.field_name]: 1,
        // });
        //
        // if (this.form.교육구분) {
        //   value.summary["안전보건교육_교육구분"].push({
        //     [this.form.교육구분.value]: 1,
        //   });
        //
        //   value.summary["안전보건교육_현장별교육구분"].push({
        //     [`${this.form.stdInfo.field_name}_${this.form.교육구분.value}`]: 1,
        //   });
        // }

        this.$emit("input", value);
      },
    },
    "form.stdInfo.field_name": {
      immediate: true,
      handler(value) {
        if (value) {
          this.form.공장 = value;
        }
      },
    },
    'form.참석자명단': {
      immediate: true,
      deep: true,
      handler() {
        this.updateSortedList();
      }
    },
    orderByParticipant: {
      deep: true,
      handler() {
        this.updateSortedList();
      }
    },
    lastSortedField() {
      this.updateSortedList();
    }
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    // ======================= FORM =======================
    changeTarget1(index, data) {
      if (index === null || data === null) return;

      if (this.form.팀업체[index].팀1차) {
        this.form.팀업체[index].팀1차 = {};
      }
      if (this.form.팀업체[index].팀2차) {
        this.form.팀업체[index].팀2차 = {};
      }

      this.form.팀리스트1차[index] = data.child ? data.child : [];
      this.form.팀리스트2차[index] = [];
    },
    changeTarget2(index, data) {
      if (!this.form.팀업체[index].팀1차 || this.form.팀업체[index].팀1차.value !== "직접입력") {
        this.form.팀업체[index].팀커스텀 = "";
      }

      if (index === null || data === null) return;

      if (this.form.팀업체[index].팀2차) {
        this.form.팀업체[index].팀2차 = {};
      }

      this.form.팀리스트2차[index] = data.child ? data.child : [];
    },
    onSelectHistory(history) {
      if (history && history.length > 0) {
        const newParticipants = [...this.form.참석자명단];

        for (const item of history) {
          // user_id로 중복 여부 확인
          const isDuplicate = newParticipants.some((existing) => existing.user_id === item.user_id);

          // 중복이 아닌 경우에만 추가
          if (!isDuplicate) {
            const 서명 = item.raw.user && item.raw.user.signature ? item.raw.user.signature.path : "";
            newParticipants.push({
              id: Math.random().toString(36).substr(2, 9),
              업체명: item.업체명,
              소속: item.소속,
              직종: item.직종,
              이름: item.이름,
              휴대폰번호: item.휴대폰번호,
              서명,
              교육평가: "생략",
              user_id: item.user_id,
              직책: item.직책,
            });
          }
        }

        // 새 배열로 할당
        this.form.참석자명단 = newParticipants;
        this.form.교육인원참석자수 = this.form.참석자명단.length;
      }
    },

    isCustomTeam(index) {
      if (!this.form.팀업체[index]) return false;
      return this.form.팀업체[index].팀1차 && this.form.팀업체[index].팀1차.value === "직접입력";
    },
    addTeam() {
      this.form.팀업체.push({
        공장: {},
        팀1차: {},
        팀2차: {},
        팀커스텀: "",
      });
      this.form.팀리스트1차.push([]);
      this.form.팀리스트2차.push([]);
    },
    removeTeam(index) {
      this.form.팀업체.splice(index, 1);
      this.form.팀리스트1차.splice(index, 1);
      this.form.팀리스트2차.splice(index, 1);
    },
    teamList1(index) {
      return this.form.팀리스트1차[index];
    },
    teamList2(index) {
      return this.form.팀리스트2차[index];
    },

    selectEducationType(item) {
      this.form.교육구분내용 = "";
      this.form.교육진행[0].교육명 = item.text;

      const content = educationContent[item.value];
      this.form.교재명 = content ? content : "";
    },

    changeDiff(value) {
      if (!value) return;
      this.form.교재명 = value.textarea ? value.textarea : "";
    },

    onClickOrders(target) {
      console.log('onClickOrders called with target:', target);

      // 다른 필드들을 모두 'asc'로 초기화
      Object.keys(this.orderByParticipant).forEach(key => {
        if (key !== target) {
          this.orderByParticipant[key] = 'asc';
        }
      });

      // 현재 정렬 방향을 토글
      this.orderByParticipant[target] = this.orderByParticipant[target] === "asc" ? "desc" : "asc";

      // 마지막 정렬 필드 기록
      this.lastSortedField = target;

      console.log(`Sorted by ${target} (${this.orderByParticipant[target]})`);
    },

    updateSortedList() {
      if (!this.form.참석자명단 || this.form.참석자명단.length === 0) {
        this.sortedParticipants = [];
        return;
      }

      // 원본 배열을 복사하여 정렬
      const sorted = [...this.form.참석자명단];

      // 현재 정렬 필드 찾기 (lastSortedField 우선, 없으면 기본값)
      const currentSortField = this.lastSortedField || 'no';

      this.sortedParticipants = sorted.sort((a, b) => {
        let aValue = a[currentSortField] || '';
        let bValue = b[currentSortField] || '';

        // No.의 경우 원본 배열에서의 인덱스 기반으로 정렬
        if (currentSortField === 'no') {
          aValue = this.form.참석자명단.indexOf(a) + 1;
          bValue = this.form.참석자명단.indexOf(b) + 1;
        }

        let comparison = 0;
        const aNum = Number(aValue);
        const bNum = Number(bValue);

        if (!isNaN(aNum) && !isNaN(bNum)) {
          comparison = aNum - bNum;
        } else {
          comparison = String(aValue).localeCompare(String(bValue), 'ko');
        }

        return this.orderByParticipant[currentSortField] === "asc" ? comparison : -comparison;
      });
    },

    handleCustomRemoveButton(checkData) {
      if (checkData && checkData.length > 0) {
        // 체크된 항목들의 ID를 가져옴
        const idsToRemove = checkData;

        // 원본 데이터(form.참석자명단)에서 해당 ID들을 제거
        this.form.참석자명단 = this.form.참석자명단.filter(
          item => !idsToRemove.includes(item.id)
        );

        // 교육인원참석자수 업데이트
        this.form.교육인원참석자수 = this.form.참석자명단.length;

        console.log('원본 데이터에서 삭제 완료:', idsToRemove);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.table-header {
  padding: 10px 0;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}
</style>
